<div class="d-flex">
  <mat-form-field appearance="outline" color="accent">
    <input
      id="inText"
      matInput
      [value]="input"
      (keyup)="setInput(inputElement.value)"
      (keyup.enter)="setFilter($event)"
      [placeholder]="'filters.placeHolder' | translate"
      #inputElement
    />
  </mat-form-field>
  <button (click)="hitEnter()" mat-flat-button color="accent">
    <mat-icon svgIcon="iconFilter" class="d-inline-flex"></mat-icon>
    <p>{{ 'filters.button' | translate }}</p>
  </button>
</div>
<!-- / filter-wrapper -->
